import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	actionEditPageDetails: {
		id: 'hub-home.page-action-menu.edit-page-details',
		defaultMessage: 'Edit details',
		description: 'Action to edit the page details in the page action menu',
	},
	actionDuplicatePage: {
		id: 'hub-home.page-action-menu.duplicate-page',
		defaultMessage: 'Duplicate',
		description: 'Action to duplicate the page in the page action menu',
	},
	actionDeletePage: {
		id: 'hub-home.page-action-menu.delete-page',
		defaultMessage: 'Delete',
		description: 'Action to delete the page in the page action menu',
	},
	moreActions: {
		id: 'hub-home.page-action-menu.more-actions',
		defaultMessage: 'More actions',
		description: 'Aria label for the more actions button in the page action menu',
	},
});

export default messages;

